<template>
  <div>
    <div @click="onClick" style="cursor: pointer;">
      <b-img fluid :src="video.image_url" :class="inCard ? (aloneInCard ? 'card-img' : 'card-img-top') : ''" />
    </div>
    <div v-if="block && block.meta && block.meta.html">
        <b-button class="btn-branded mb-3" @click="onClick">
            {{ trans('watch_video') }}
        </b-button>
    </div>
    <b-modal
      :id="modalId"
      :title="capitalize(type)"
      no-enforce-focus
      size="lg"
      hide-footer
      @shown="iframeCheck"
      :hide-backdrop="isInIframe"
    >
      <div class="text-center">
        <video v-if="isVideo" :src="video.video_url" type="mp4" autoplay :poster="video.image_url" controls class="w-100 card-img-top" :controlsList="noDownload ? 'nodownload' : ''" :muted="organization.id == 1093 || organization.id == 667" />
        <iframe v-if="isYoutube" width="560" height="315" :src="`https://www.youtube.com/embed/${youtubeId}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <div v-if="isVimeo" style="padding:56.25% 0 0 0;position:relative;">
          <iframe :src="`https://player.vimeo.com/video/${vimeoId}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=164141${vimeoPrivateId ? ('&amp;h=' + vimeoPrivateId) : ''}`" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </div>
        <div v-if="block && block.meta && block.meta.html" v-html="block.meta.html"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: {
      video: Object, // Cannot be null! id (media), video_url, image_url
      block: Object,
      organization: Object,
      inCard: {
        type: Boolean,
        default: true,
      },
      aloneInCard: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        capitalize: _.capitalize,
        yPos: null,
      }
    },
    computed: {
      modalId() {
        return `video-modal-${this.video ? this.video.id : ''}`
      },
      isVideo() {
        return (this.video.video_url || '').indexOf('https://am.lol') === 0
      },
      youtubeId() {
        return _.getYouTubeVideoId(this.video.video_url)
      },
      isYoutube() {
        return this.youtubeId != null
      },
      vimeoId() {
        return _.getVimeoVideoId(this.video.video_url)
      },
      isVimeo() {
        return this.vimeoId != null
      },
      vimeoPrivateId() {
        if (!this.isVimeo) return null
        return _.getVimeoPrivateId(this.video.video_url)
      },
      type() {
        if (this.isVimeo) return 'vimeo'
        if (this.isYoutube) return 'youtube'
        return 'video'
      },
      noDownload() {
        if (this.organization && this.organization.id == 667) {
            return true
        }
        return false
      },
      isInIframe() {
        return window !== window.parent
      }
    },
    methods: {
      onClick(event) {
        if (event) {
            event.preventDefault()
        }

        this.yPos = event.pageY
        this.$bvModal.show(this.modalId)
      },
      iframeCheck() {
        if (window !== window.parent) {
            $('#' + this.modalId).css({top: this.yPos - 100})
        }
      }
    },
    mounted() {
        window.videoWrapper = this
    },
  }
</script>
